import {get} from '../utils'

export default host => (clientId) =>
  get(`${host}/clients/${clientId}/musics/recents?per_page=30&include=versions_count;audio:id,duration,url;tags;favorite;audio.waveform;albums.image`)
    .then(response => response.json())
    .then(json => json.data)
